import { SET_FLEX_DATES_EXD } from '../../../actions/actionTypes'

export function flexDatesExpressDeals(state = [], action) {
  switch (action.type) {
    case SET_FLEX_DATES_EXD:
      return [...state, ...action.flexDatesExpressDeals]
    default:
      return state
  }
}
